
    export interface IConfirmNewDocusignRemoteSendScope extends ng.IScope {
        confirmNewDocusignRemoteSendCtrl: ConfirmNewDocusignRemoteSendCtrl;
    }

    export class ConfirmNewDocusignRemoteSendCtrl {

        public static $inject = ['$scope', '$modalInstance', '$state', 'documentType', 'emailAddress'];

        constructor(
            public $scope: IConfirmNewDocusignRemoteSendScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public $state: angular.ui.IStateService,
            public documentType: string,
            public emailAddress: string) {

            $scope.confirmNewDocusignRemoteSendCtrl = this;

        }

        public confirmRemoteSend = (): void => {
            this.$modalInstance.close();
        }

        public closeModal = (): void => {
            this.$modalInstance.dismiss();
        }

    }
